import { useMutation } from '@tanstack/react-query'
import { fetcher } from 'repositories/BerthApi/berthApiClient'
import { findDriverEndpoint } from 'repositories/BerthApi/findDriver/endpoint'
import type {
  FindDriverData,
  FindDriverParams,
  FindDriverResponse,
} from 'repositories/BerthApi/findDriver/type'

export type { FindDriverData }

export function useFindDriver() {
  return useMutation<FindDriverData | null, unknown, FindDriverParams>({
    mutationFn: async (params) => {
      const res = await fetcher<FindDriverResponse>(
        findDriverEndpoint({ driverPhone: params.driverPhone, driverName: params.driverName })
      )
      const data = res.data
      if (!data || !data.driverId) return null
      return data
    },
  })
}
